// ── Site Selector — dropdown to pick which site to view ──

import type { SiteNode } from "../types/graph";

interface SiteSelectorProps {
  sites: SiteNode[];
  selectedSiteId: string | null;
  onSelect: (siteId: string | null) => void;
  loading?: boolean;
}

export default function SiteSelector({
  sites,
  selectedSiteId,
  onSelect,
  loading,
}: SiteSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <label className="text-xs text-fl-sand-80 whitespace-nowrap">Site</label>
      <select
        value={selectedSiteId ?? ""}
        onChange={(e) => onSelect(e.target.value || null)}
        disabled={loading || sites.length === 0}
        className="px-2 py-1 rounded text-xs bg-fl-forest/60 text-white border border-fl-forest-60/40
                   focus:outline-none focus:ring-1 focus:ring-fl-leaf/50 disabled:opacity-50
                   appearance-none cursor-pointer min-w-[140px]"
      >
        {sites.length === 0 && <option value="">Loading…</option>}
        {sites.map((site) => (
          <option key={site.id} value={site.id}>
            {site.name}
          </option>
        ))}
      </select>
    </div>
  );
}
